import type { CameraGridLayout } from '../../../core/models/browser-tab.models';
import { cameraGridCellsPerPage, normalizeCameraGridLayout } from '@ecam/eventq-components';

/** Ascending capacity — used when auto-growing the grid for selection count. */
const LAYOUT_ORDER: CameraGridLayout[] = ['1x1', '2x2', '3x3', '4x3'];

export function layoutForCameraCount(count: number): CameraGridLayout {
  if (count <= 1) {
    return '1x1';
  }
  if (count <= 4) {
    return '2x2';
  }
  if (count <= 9) {
    return '3x3';
  }
  return '4x3';
}

/** Grow layout up to 4x3 so selected cameras fit on a single page when possible. */
export function growLayoutForCount(
  current: string,
  selectedCount: number,
): CameraGridLayout {
  const normalizedCurrent = normalizeCameraGridLayout(current);
  const needed = layoutForCameraCount(selectedCount);
  const currentIndex = LAYOUT_ORDER.indexOf(normalizedCurrent);
  const neededIndex = LAYOUT_ORDER.indexOf(needed);
  return LAYOUT_ORDER[Math.max(currentIndex, neededIndex)] ?? '4x3';
}

export function cameraGridTotalPages(selectedCount: number, layout: string): number {
  const cells = cameraGridCellsPerPage(layout);
  return Math.max(1, Math.ceil(Math.max(0, selectedCount) / cells));
}

export function clampCameraGridPage(page: number, totalPages: number): number {
  return Math.min(Math.max(1, page), Math.max(1, totalPages));
}

export function pageCameraIds(
  selectedIds: readonly string[],
  layout: string,
  page: number,
): string[] {
  const cells = cameraGridCellsPerPage(layout);
  const start = (page - 1) * cells;
  return selectedIds.slice(start, start + cells);
}
